/**
 * Prestige Theme - Collection Filtering & Sorting
 */
class CollectionFilters {
    constructor() {
        this.form = document.getElementById('FacetsFiltersForm');
        this.container = document.getElementById('ProductGridContainer');
        this.containerOuter = document.getElementById('CollectionContainer');

        if (!this.form || !this.container) return;

        this.onFormChange = this.onFormChange.bind(this);
        this.form.addEventListener('input', window.Theme.utils.debounce(this.onFormChange, 500));

        // Handle price range inputs specifically if needed (often debounced longer)
        this.form.querySelectorAll('input[type="number"]').forEach(input => {
            input.addEventListener('change', this.onFormChange);
        });

        // Handle sort by change
        const sortBy = this.form.querySelector('#SortBy');
        if (sortBy) {
            sortBy.addEventListener('change', this.onFormChange);
        }

        // Handle clicks on Reset and Active filters
        this.containerOuter.addEventListener('click', (e) => {
            const link = e.target.closest('[data-facet-reset], .active-facet, .active-facet__clear-all');
            if (link) {
                e.preventDefault();
                this.updateView(link.href);
            }
        });

        // Handle history navigation (back/forward)
        window.addEventListener('popstate', (e) => {
            this.updateView(window.location.href, false);
        });
    }

    onFormChange(event) {
        const formData = new FormData(this.form);
        const searchParams = new URLSearchParams(formData).toString();
        const url = `${window.location.pathname}?${searchParams}`;

        this.updateView(url);
    }

    async updateView(url, updateHistory = true) {
        this.container.classList.add('is-loading');

        try {
            // Get the section ID from the container if possible, or use a default
            // Assuming the section ID is 'collection' based on common Shopify patterns
            // but let's try to find it dynamically.
            const sectionId = this.containerOuter.closest('.shopify-section').id.replace('shopify-section-', '');
            const ajaxUrl = `${url}${url.includes('?') ? '&' : '?'}section_id=${sectionId}`;

            const response = await fetch(ajaxUrl);
            if (!response.ok) throw new Error('Network response was not ok');

            const html = await response.text();
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');

            // Update the inner result grid
            const newContainer = doc.getElementById('ProductGridContainer');
            const newFilters = doc.getElementById('FacetsFiltersForm');
            const newActiveFacets = doc.querySelector('.active-facets');

            if (newContainer) {
                this.container.innerHTML = newContainer.innerHTML;
            }

            if (newFilters) {
                // We update the form logic specifically to keep dropdowns open if needed,
                // or just replace it and re-bind.
                // For simplicity and robustness, replacing the parts that change.
                const currentActiveFacets = this.form.closest('.collection-filters').querySelector('.active-facets');
                const nextActiveFacets = doc.querySelector('.active-facets');

                if (currentActiveFacets && nextActiveFacets) {
                    currentActiveFacets.outerHTML = nextActiveFacets.outerHTML;
                } else if (nextActiveFacets) {
                    this.form.closest('.collection-filters').appendChild(nextActiveFacets);
                } else if (currentActiveFacets) {
                    currentActiveFacets.remove();
                }

                // Update counts and selected status in the form without losing focus/open state if possible
                // But for a first pass, replacing the form is safer.
                this.updateFilterForm(doc);
            }

            if (updateHistory) {
                window.history.pushState({ url }, '', url);
            }

        } catch (error) {
            console.error('Filtering error:', error);
        } finally {
            this.container.classList.remove('is-loading');
        }
    }

    updateFilterForm(doc) {
        // Helper to update specific parts of the form without closing everything
        const newForm = doc.getElementById('FacetsFiltersForm');
        if (!newForm) return;

        // Update selected counts
        this.form.querySelectorAll('.facet-display__selected').forEach((el, i) => {
            const newVal = newForm.querySelectorAll('.facet-display__selected')[i];
            if (newVal) el.textContent = newVal.textContent;
        });

        // Update individual list item counts and disabled states
        this.form.querySelectorAll('.facet-display__item').forEach((item) => {
            const input = item.querySelector('input');
            const newMatch = newForm.querySelector(`input[name="${input.name}"][value="${input.value}"]`);
            if (newMatch) {
                const count = item.querySelector('.count');
                const newCount = newMatch.closest('.facet-display__item').querySelector('.count');
                if (count && newCount) count.textContent = newCount.textContent;
                input.disabled = newMatch.disabled;
            }
        });

        // Re-bind sort by if it was replaced
        const newSortBy = newForm.querySelector('#SortBy');
        const currentSortBy = this.form.querySelector('#SortBy');
        if (newSortBy && currentSortBy) {
            currentSortBy.value = newSortBy.value;
        }
    }
}

document.addEventListener('DOMContentLoaded', () => {
    window.Theme = window.Theme || {};
    window.Theme.collectionFilters = new CollectionFilters();
});
